/* eslint-disable import/order */
import { getConfigField } from 'src/models/lmsConfig/queries';
import axios from 'src/workspace/axios';
import { getDecryptedEnvValue, getWebPlatformPrefixPath } from '../utils';
import {
  checkIfFCMKeysPresent,
  getFCMConfig,
  handleOnMessageReceived,
} from './queries';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

let messaging: firebase.messaging.Messaging | null = null;

const registerFcmDeviceWithBackend = (
  messagingInstance: firebase.messaging.Messaging,
  swRegistration: ServiceWorkerRegistration,
) => {
  const vapidKey = getDecryptedEnvValue('FCM_VAPID_KEY');

  messagingInstance
    .getToken({
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    })
    .then((token) => {
      if (token) {
        // eslint-disable-next-line no-console
        console.log('[FCM] Token:', token);

        const authToken = getConfigField('auth_token');
        axios.post('/notifications/register', {
          device_token: token,
          device_type: 'web',
          build_type: '1.0.0',
          auth_token: authToken,
        });
      }
    });
};

// eslint-disable-next-line max-lines-per-function
export const initFCM = async (): Promise<void> => {
  if (!checkIfFCMKeysPresent()) return;

  const config = getFCMConfig();

  if (firebase.apps.length > 0) {
    messaging = firebase.messaging();
    if (Notification.permission !== 'granted') {
      return;
    }
    try {
      const swRegistration = await navigator.serviceWorker.ready;
      registerFcmDeviceWithBackend(messaging, swRegistration);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[FCM] Failed to refresh token after rehydrate', err);
    }
    return;
  }

  firebase.initializeApp(config);
  messaging = firebase.messaging();

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    // eslint-disable-next-line no-console
    console.warn('[FCM] Notification permission denied');
    return;
  }

  let swRegistration: ServiceWorkerRegistration | undefined;
  if ('serviceWorker' in navigator) {
    try {
      const swUrl = `${getWebPlatformPrefixPath()}/vymoWeb/worker/firebase-messaging-sw.js?firebaseConfig=${encodeURIComponent(
        JSON.stringify(config),
      )}`;
      swRegistration = await navigator.serviceWorker.register(swUrl);
      swRegistration.update();
      try {
        await navigator.serviceWorker.ready;
        if (swRegistration) {
          registerFcmDeviceWithBackend(messaging, swRegistration);
        }

        messaging.onMessage((payload) => {
          // eslint-disable-next-line no-console
          console.log('[FCM Message] Getting message: ', payload);

          handleOnMessageReceived(payload);
        });

        const channel = new BroadcastChannel('firebase-sw-messages');
        channel.addEventListener('message', (event) => {
          handleOnMessageReceived(event.data);
          // eslint-disable-next-line no-console
          console.log('[FCM Channel Message event]', event);
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[FCM] Failed to get token', err);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[FCM] Service Worker registration failed', err);
    }
  }
};
